// Theme tokens and design system constants
import { darkColors, lightColors, type ColorPalette, type ThemeMode } from './colors';

// Export color palettes
export { darkColors, lightColors };
export type { ColorPalette, ThemeMode };

// Helper function to get colors by theme mode
export const getColors = (mode: ThemeMode): ColorPalette => {
  return mode === 'dark' ? darkColors : lightColors;
};

export const typography = {
  fontFamily: [
    'Alegreya sans',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    'sans-serif',
  ].join(','),
  weights: {
    light: 100,
    regular: 400,
    medium: 500,
    bold: 700,
  },
} as const;

export const spacing = {
  unit: 8, // Base spacing unit (8px)
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
} as const;

export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;
